<template>
    <div class="mx-auto prose lg:prose-sm">
        <h1 class="text-center">
            Conditions générales d'utilisation de la plateforme
            <br />« Business Plan Interactif »
        </h1>

        <h3>ARTICLE 1 : Objet</h3>
        <p>
            Les présentes « conditions générales d'utilisation » ont pour objet
            l'encadrement juridique de l’utilisation de l’application « Business
            Plan Interactif » et de ses services.
        </p>
        <p>
            Ce contrat est conclu entre :
            <br />Le gérant de l’application, ci-après désigné Centre Régional
            d’Investissement de Marrakech-Safi, Et, <br />Toute personne physique ou
            morale souhaitant accéder à l’application et à ses services,
            ci-après appelé « l’Utilisateur ».
        </p>
        <p>
            Les conditions générales d'utilisation doivent être acceptées par
            tout Utilisateur, et son accès à l’application vaut acceptation de
            ces conditions.
        </p>
        <h3>ARTICLE 2 : Mentions légales</h3>
        <p>
            L’application Business Plan Interactif est éditée par la société
            DIGITAL BUTTERFLY S.A.R.L au capital social de 100 000 Dhs, dont le
            siège social est situé à Angle Rue Istiklal et Rue Ibn Rochd IMM Al
            Mohandissine 4ème étage N°A 29 Oujda, Maroc.
        </p>
        <h3>
            ARTICLE 3 : accès aux services
        </h3>
        L’Utilisateur de l’application Business Plan Interactif a accès aux
        services suivants :
        <ul>
            <li>Générer un business plan ;</li>
            <li>L’offre foncière de la Région  Marrakech-Safi ;</li>
            <li>
                Les couts des facteurs de production de la Région de Marrakech-Safi;
            </li>
            <li>Les études sectorielles pour la Région de Marrakech-Safi ;</li>
        </ul>
        Tout Utilisateur ayant accès à internet peut accéder gratuitement et
        depuis n’importe où à l’application. Les frais supportés par
        l’Utilisateur pour y accéder (connexion internet, matériel informatique,
        etc.) ne sont pas à la charge de l’Éditeur.
        <p>
            Les services de l’application ne sont pas accessibles pour
            l’Utilisateur que s’il est membre inscrit (c’est-à-dire qu’il est
            identifié à l’aide de ses identifiants de connexion).
        </p>
        <p>
            L’application et ses différents services peuvent être interrompus ou
            suspendus par l’Éditeur, notamment à l’occasion d’une maintenance,
            sans obligation de préavis ou de justification.
        </p>
        <h3>ARTICLE 4 : Responsabilité de l’Utilisateur</h3>
        <p>
            L'Utilisateur est responsable des risques liés à l’utilisation de
            son identifiant de connexion et de son mot de passe.
        </p>
        <p>
            Le mot de passe de l’Utilisateur doit rester secret. En cas de
            divulgation de mot de passe, l’Éditeur décline toute responsabilité.
        </p>
        <p>
            L’Utilisateur assume l’entière responsabilité de l’utilisation qu’il
            fait des informations et contenus présents sur l’application
            Business Plan Interactif.
        </p>
        <p>
            Tout usage du service par l'Utilisateur ayant directement ou
            indirectement pour conséquence des dommages doit faire l'objet d'une
            indemnisation au profit du Gérant et de l’Editeur.
        </p>
        L’application permet aux membres de :
        <ul>
            <li>
                Renseigner leurs informations (Téléphone, adresse mail, adresse
                postale…).
            </li>
        </ul>
        <p>
            Le membre s’engage à tenir des propos respectueux des autres et de
            la loi et accepte que ces publications soient modérées ou refusées
            par le Gérant, sans obligation de justification.
        </p>
        L’Éditeur s'engage à citer le membre en cas d’utilisation des
        informations saisies dans l’application.
        <h3>ARTICLE 5 : Responsabilité de l’Éditeur</h3>
        <p>
            Tout dysfonctionnement du serveur ou du réseau ne peut engager la
            responsabilité de l’Éditeur.
        </p>
        <p>
            De même, la responsabilité de l’application ne peut être engagée en
            cas de force majeure ou du fait imprévisible et insurmontable d'un
            tiers.
        </p>
        <p>
            L’application Business Plan Interactif s'engage à mettre en œuvre
            tous les moyens nécessaires pour garantir la sécurité et la
            confidentialité des données. Toutefois, il n’apporte pas une
            garantie de sécurité totale.
        </p>
        <p>
            L’Éditeur se réserve la faculté d’une non-garantie de la fiabilité
            des sources, bien que les informations diffusées sur l’application
            soient réputées fiables.
        </p>
        <h3>ARTICLE 6 : Propriété intellectuelle</h3>
        <p>
            Les contenus de l’application Business Plan Interactif (logos,
            textes, éléments graphiques, etc.) sont protégés par le droit
            d’auteur, en vertu du Code de la propriété intellectuelle.
        </p>
        <p>
            L’Utilisateur devra obtenir l’autorisation de l’éditeur de
            l’application avant toute reproduction, copie ou publication de ces
            différents contenus.
        </p>
        <p>
            Ces derniers peuvent être utilisés par les utilisateurs à des fins
            privées ; tout usage commercial est interdit.
        </p>
        <p>
            L’Utilisateur est entièrement responsable de tout contenu qu’il met
            en ligne et il s’engage à ne pas porter atteinte à un tiers.
        </p>
        <p>
            L’Éditeur et le Gérant de l’application se réserve le droit de
            modérer ou de supprimer librement et à tout moment les contenus mis
            en ligne par les utilisateurs, et ce sans justification.
        </p>
        <h3>ARTICLE 7 : Données personnelles</h3>
        <p>
            L’Utilisateur doit obligatoirement fournir des informations
            personnelles pour procéder à son inscription sur la plateforme.
        </p>
        <p>
            L’adresse électronique de l’utilisateur pourra notamment être
            utilisée par l’application Business Plan Interactif pour la
            communication d’informations diverses et la gestion du compte.
        </p>
        <p>
            La plateforme garantit le respect de la vie privée de l’utilisateur,
            conformément à la loi en vigueur.
        </p>
        L'Utilisateur dispose d'un droit d'accès, de rectification, de
        suppression et d'opposition de ses données personnelles. L'Utilisateur
        exerce ce droit via :
        <ul>
            <li>Son espace personnel sur l’application ;</li>
            <li>Par mail à l’adresse mail de l’administrateur ;</li>
        </ul>
        <h3>ARTICLE 8 : Liens hypertextes</h3>
        <p>
            Les domaines vers lesquels mènent les liens hypertextes présents sur
            l’application n’engagent pas la responsabilité de l’Éditeur de
            l’application, qui n’a pas de contrôle sur ces liens.
        </p>
        <p>
            Il est possible pour un tiers de créer un lien vers une page de
            l’application sans autorisation expresse de l’éditeur.
        </p>
        <h3>ARTICLE 9 : Évolution des conditions générales d’utilisation</h3>
        <p>
            L’application Business Plan Interactif se réserve le droit de
            modifier les clauses de ces conditions générales d’utilisation à
            tout moment et sans justification.
        </p>
        <h3>ARTICLE 10 : Durée du contrat</h3>
        <p>
            La durée du présent contrat est indéterminée. Le contrat produit ses
            effets à l'égard de l'Utilisateur à compter du début de
            l’utilisation du service.
        </p>
        <h3>ARTICLE 11 : Droit applicable et juridiction compétente</h3>
        <p>Le présent contrat dépend de la législation Marocaine.</p>
        <p>
            En cas de litige non résolu à l’amiable entre l’Utilisateur et
            l’Éditeur, les tribunaux de la ville d’Oujda sont compétents pour
            régler le contentieux.
        </p>
    </div>
</template>

<script>
export default {};
</script>

<style></style>
